export const RouteState = { render: () => null };

export function sectionRoutes({ meta, tabKey, routes }) {
  return routes.map(([path, name, tab, extra = {}]) => ({
    path,
    name,
    component: RouteState,
    ...extra,
    meta: { ...meta, [tabKey]: tab, ...extra.meta },
  }));
}
